import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { grid } from '@finect/tabular-utils/grid';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { MainContent } from '@finect/tabular-core/MainContent';

export const FullHeightContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
`;

export const MainContentStyled = styled(MainContent)`
  > h1,
  > h2 {
    display: block;
  }

  > h1 {
    ${getFont(2)}
    font-weight: 400;
    color: ${({ theme }) => theme.plus.font};
    padding-bottom: 6px !important;
  }

  > h2 {
    ${getFont(5)}
    font-weight: 450;
    color: black;
    line-height: 1;
    max-width: ${grid(7)}px;
  }

  ${maxMediaQueries.tablet`
    > h1 {
      ${getFont(0)}
      line-height: 1;
    }

    > h2 {
      ${getFont(1.75)}
      line-height: 1;
    }
  `}
`;
